export const ColorShadePositions = {
  LIGHTER: 'LIGHTER',
  LIGHT: 'LIGHT',
  MEDIUM: 'MEDIUM',
  DARK: 'DARK',
  DARKER: 'DARKER'
};